import { render, staticRenderFns } from "./ActiveSession.vue?vue&type=template&id=12aefb0a"
import script from "./ActiveSession.vue?vue&type=script&lang=js"
export * from "./ActiveSession.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports